import axiosBackEnd from "../config/axios/axios-back-end";

export const getAllUsers = async () => {
  const response = await axiosBackEnd.get("/api/users");
  return response.data;
};

export const getUserList = async () => {
  const response = await axiosBackEnd.get("/api/users/list");
  return response.data;
};

export const getSingleUser = async (id) => {
  const response = await axiosBackEnd.get(`/api/users/${id}`);
  return response.data;
};

export const userSearch = async (data) => {
  const response = await axiosBackEnd.post("/api/users/search", data);
  return response.data;
}

export const getUserHotels = async (id) => {
  const response = await axiosBackEnd.get(`/api/users/${id}/hotels`);
  return response.data;
};

export const setBulkUser = async ({ data }) => {
  const response = await axiosBackEnd.post(`/api/bulk-creation/user`, data);
  return response.data;
};

export const getUserInvitations = async (id) => {
  const response = await axiosBackEnd.get(`/api/users/${id}/invitations`);
  return response.data;
};

export const getUserByIdOrRoleId = async (data) => {
  const queryData = { user_id: data?.user_id, role_id: data?.role_id }
  const response = await axiosBackEnd.get("/api/users/legacy", {
    params: queryData,
  });
  return response.data;

};

export const updateUserStatus = async ({ data, id }) => {
  const response = await axiosBackEnd.put(`/api/users/${id}/status`, data);
  return response.data;
};

//TODO: need to replace with newer API end point
export const setUserInvitation = async ({ data }) => {
  const response = await axiosBackEnd.post(
    "/api/users/add-user-invitation",
    data,
  );
  return response.data;
};

export const addUserInvitation = async ({ data, id }) => {
  const response = await axiosBackEnd.post(
    `/api/users/${id}/invitations`,
    data,
  );
  return response.data;
};

export const getEnvelopeSignerHotels = async (data) => {
  const hotelIds = data?.hotelIds?.length ? [...data?.hotelIds] : [];
  const response = await axiosBackEnd.get(
    `/api/users/${data.id}/envelope-signers/assignment`,
    {
      params: hotelIds,
    },
  );
  return response.data;
};

// Get Application Permission
export const getApplicationPermission = async (id) => {
  const url = `/api/users/${id}/application-permissions`;
  const response = await axiosBackEnd.get(url);
  return response.data;
};

// Add Application Permissions
export const AddUserApplicationPermissions = async ({ id, data }) => {
  const url = `/api/users/${id}/application-permissions`;
  const response = await axiosBackEnd.post(url, data);
  return response.data;
};

export const createUser = async ({ data }) => {
  const url = `/api/users`;
  const response = await axiosBackEnd.post(url, data);
  return response.data;
};

export const updateUser = async ({ data }) => {
  const url = `/api/users/update`;
  const response = await axiosBackEnd.post(url, data);
  return response.data;
};

export const checkUserName = async ({ data }) => {
  const url = `/api/users/valid-username`;
  const response = await axiosBackEnd.post(url, data);
  return response.data;
};

export const checkUserNameAvailable = async (data) => {
  try {
    const response = await axiosBackEnd.post("/api/users/valid-username", data);
    return {
      alreadyExist: response.data?.error,
      error: false,
      message: response.data?.message
    };
  } catch (err) {
    return {
      alreadyExist: false,
      error: true,
    };
  }
};

export default {
  getSingleUser,
  getUserInvitations,
  getUserHotels,
  setBulkUser,
  setUserInvitation,
  addUserInvitation,
  getAllUsers,
  getApplicationPermission,
  getUserByIdOrRoleId,
  AddUserApplicationPermissions,
  getEnvelopeSignerHotels,
  createUser,
  updateUser,
  checkUserNameAvailable,
  checkUserName,
  userSearch,
};
